<div class="replacement-vehicle-label">
    <span>{{label | translate | uppercase}}</span>
</div>